import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErrorMessage } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useI18n } from "../lib/i18n";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(data.message || "Check your inbox");
    } catch (err) {
      // Even on error, show a neutral message — never reveal existence
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 lg:py-24">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">Password reset</div>
      <h1 className="font-display text-4xl font-black tracking-tighter mb-8">Forgot your password?</h1>
      {sent ? (
        <div className="border border-white/15 p-6" data-testid="forgot-sent">
          <p className="text-sm text-[#8B97AE] leading-relaxed">If an account exists for that email, a reset link has been sent. It expires in one hour.</p>
          <Button asChild className="mt-6 rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] h-11 px-5 font-semibold transition-colors">
            <Link to="/login" data-testid="forgot-goto-login">{t("auth.login")}</Link>
          </Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div>
            <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">{t("auth.email")}</Label>
            <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-white" />
          </div>
          <p className="text-xs text-[#8B97AE] leading-relaxed">Locked out from repeated failed logins? A successful password reset clears the lock and unlocks your account immediately.</p>
          <Button data-testid="forgot-submit" type="submit" disabled={busy} className="w-full rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] h-12 font-semibold transition-colors">
            {busy ? t("common.loading") : "Send reset link"}
          </Button>
        </form>
      )}
    </div>
  );
}
